/**
 * Payment-related constants
 *
 * SessionStorage keys used for preserving payment state across redirects (e.g., 3DS verification)
 */

/** SessionStorage key for storing the user's cohort (e.g., 'multi-disease') */
export const COHORT_STORAGE_KEY = 'payment_cohort';

/** SessionStorage key for storing the price experiment variant (e.g., 'control', 'experiment') */
export const PRICE_EXPERIMENT_STORAGE_KEY = 'payment_price_experiment';

/**
 * Stripe decline codes commonly returned when HSA/FSA debit cards are
 * rejected due to merchant-category restrictions.
 */
export const HSA_FSA_DECLINE_CODES = new Set([
  'generic_decline',
  'transaction_not_allowed',
  'do_not_honor',
  'invalid_transaction',
  'service_not_allowed',
  'transaction_not_permitted',
]);
